import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWindsurfNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M45.686 42.918L46.54 41H29.53l1.66-3.11A36.42 36.42 0 0035.46 22h.018v-2A36.5 36.5 0 0031.19 3.47L29.34 0h-4.89L9.03 29H7v2h24.91a35.455 35.455 0 01-2.49 5.96l-.79 1.48L16.92 33h-4.76l15.53 7.21-.42.79H3v2h40.242a5.592 5.592 0 01-4.293 2H3v2h35.949a7.612 7.612 0 006.737-4.082zM25.65 2h2.49l1.28 2.41A34.524 34.524 0 0132.085 11h-11.22l4.785-9zM19.8 13h12.8c.527 2.298.817 4.643.867 7H16.08l3.72-7zm-8.51 16l3.72-7h18.44a33.93 33.93 0 01-.98 7H11.29z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsWindsurfNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWindsurfNormalLarge;
